import { type QuestionsProps } from "@/features/questionnaire/types";
import { getTranslation } from "@/features/questionnaire/utils";
import {
  ovalIcon,
  rectangleVerticalDoubleIcon,
  rectangleVerticalIcon,
  shapeCornerIcon,
  shapeFreeIcon,
  shapeLIcon,
  shapeOrganicIcon,
  shapeUIcon,
} from "@repo/skapa";
import { Pill } from "@repo/skapa";
import { NumberField, useSettings } from "@repo/ui";
import { useState } from "react";

export const ShapeQuestion = ({
  answer,
  onAnswerIdAnswered,
  question,
  onFreeTextAnswered,
}: QuestionsProps) => {
  const { language } = useSettings();

  const [extraInputValues, setExtraInputValues] = useState<
    Record<string, string>
  >(answer?.answerFreeText ? JSON.parse(answer.answerFreeText) : {});

  if (!question?.answers) {
    return null;
  }

  const selectedAnswerId = answer?.answerIds?.[0];
  const selectedAnswer = question.answers.find(
    (ans) => ans.answer_id_key === selectedAnswerId
  );

  const handleButtonClick = (answerId: string) => {
    const updatedSelectedIds = [answerId];
    onAnswerIdAnswered?.(updatedSelectedIds);
  };

  const handleExtraInputChange = (answerId: string, value: string) => {
    setExtraInputValues((prevValues) => {
      const updatedValues = {
        ...prevValues,
        [answerId]: value,
      };
      onFreeTextAnswered?.(JSON.stringify(updatedValues));
      return updatedValues;
    });
  };

  const getIconPath = (mediaSource: string) => {
    switch (mediaSource) {
      case "cornerShapeIcon":
        return shapeCornerIcon;
      case "freeShapeIcon":
        return shapeFreeIcon;
      case "lShapeIcon":
        return shapeLIcon;
      case "organicShapeIcon":
        return shapeOrganicIcon;
      case "uShapeIcon":
        return shapeUIcon;
      case "straightShapeIcon":
        return rectangleVerticalIcon;
      case "doubleStraightShapeIcon":
        return rectangleVerticalDoubleIcon;
      case "ovalShapeIcon":
        return ovalIcon;
    }
  };

  return (
    <>
      <div>
        {question.answers.map((option) => (
          <Pill
            key={`${question.question_id_key}-${option.answer_id_key}`}
            label={getTranslation(
              option.answer_translation ?? [],
              language,
              option.answer_name
            )}
            leadingIcon={getIconPath(option.answer_mediaSource ?? "")}
            selected={selectedAnswerId === option.answer_id_key}
            className="demo-pill--in-carousel-story"
            size="small"
            onClick={() => handleButtonClick(option.answer_id_key)}
            style={{ margin: "4px" }}
          />
        ))}
      </div>

      {selectedAnswer?.answer_extra_inputs?.map((extraInput) => (
        <NumberField
          id={`extra-${extraInput.answer_extra_inputs_id_key}`}
          key={`extra-${extraInput.answer_extra_inputs_id_key}`}
          label={getTranslation(
            extraInput.answer_extra_inputs_translation ?? [],
            language,
            extraInput.answer_extra_input_name || ""
          )}
          value={
            extraInputValues[
              `${selectedAnswerId}_${extraInput.answer_extra_inputs_id_key}`
            ] || ""
          }
          onChange={(value) =>
            handleExtraInputChange(
              `${selectedAnswerId}_${extraInput.answer_extra_inputs_id_key}`,
              value || ""
            )
          }
        />
      ))}
    </>
  );
};
